import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { RevenueMonth } from 'src/lib/entity/revenue'
import { ConsoleLogger } from 'src/lib/console-logger'
import { ChangePageRequest } from 'src/lib/entity/revenue'
import { Subscription } from 'rxjs'

@Component({
  selector: 'maglive-revenue-index',
  templateUrl: './revenue-index.component.html',
  styleUrls: ['./revenue-index.component.scss'],
})
export class RevenueIndexComponent implements OnInit, OnDestroy {
  revenueMonths: RevenueMonth[] | 'NOT_FOUND'

  @Input() selectedMagazineId: number
  @Output() changePageEvent = new EventEmitter<ChangePageRequest>()

  /* Subscription */
  private getRevenueMonthsHistorySub: Subscription | undefined

  constructor(private logger: ConsoleLogger) {}

  ngOnInit(): void {
    this.getRevenueMonthsHistorySub = MagliveApiClient.getRevenueMonthsHistory(
      this.selectedMagazineId
    ).subscribe((value) => {
      if (value.length === 0) {
        this.revenueMonths = 'NOT_FOUND'
      } else {
        this.revenueMonths = value
      }
      this.logger.info(
        this.constructor.name,
        'getRevenueMonthsHistory',
        'revenueMonths',
        this.revenueMonths
      )
    })
  }

  ngOnDestroy(): void {
    if (this.getRevenueMonthsHistorySub) {
      this.getRevenueMonthsHistorySub.unsubscribe()
    }
  }

  showRevenueDetail(yearMonth: string) {
    this.changePageEvent.emit({ name: 'DETAIL', yearMonth: yearMonth })
  }
}
